import React, { useState, useEffect } from 'react';
import * as C from '../common-styles.styles';
import {
  Header,
  Container,
  FooterWrap,
  Footer
} from '../hotels-attractions-information/hotels-attractions-information.styles';
import * as S from './flight-hotel.styles';

const FlightHotel = ({ city_sectors, headerTitle, city, isDweb = false }) => {
  if (city_sectors && city_sectors.legth < 1) {
    return null;
  }

  const [showMore, setShowMore] = useState(false);
  const [showCount, setShowCount] = useState(4);

  useEffect(() => {
    if (showMore === false) {
      setShowCount(4);
    } else {
      setShowCount(city_sectors.length);
    }
  }, [showMore]);

  const handleClickView = () => {
    setShowMore(!showMore);
  };

  return (
    <C.Wrap isDweb={isDweb}>
      <C.CommonDetails className="flexCol">
        <Header>{headerTitle}</Header>
        {city_sectors.slice(0, showCount).map(
          (city_sector, index) =>
            city_sector && (
              <Container key={index} className="flexCol">
                <div className="dF">
                  <S.FlightServe className="flexCol padR5">
                    <div>{`${city_sector.n} Flights`}</div>
                    <div className="greyCnt padT5">{`${city_sector.n} is approx ${city_sector.dis} kms from ${city.name} (${city.iata})`}</div>
                  </S.FlightServe>
                  <S.HotelsServe className="txtRight">
                    <a href={city_sector.city_hotels_link}>
                      {' '}
                      <S.HotelIco
                        src="https://gos3.ibcdn.com/img-1460547056.png"
                        alt="Hotels"
                      />{' '}
                      {`${city_sector.nh} Hotels In ${city_sector.n}`}
                    </a>
                  </S.HotelsServe>
                </div>
              </Container>
            )
        )}
        <FooterWrap>
          <Footer onClick={handleClickView}>{showMore ? 'View Less(-)' : 'View More(+)'}</Footer>
        </FooterWrap>
      </C.CommonDetails>
    </C.Wrap>
  );
};

export default FlightHotel;
